module.exports = __webpack_public_path__ + "static/media/image 17.64af955a.png";